'use client';
import { createBrowserClient } from '@supabase/ssr';

/**
 * Creates a browser Supabase client using @supabase/ssr with custom cookie handling
 * Only works in browser environment (not during SSR)
 */
export function createClient() {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return null;
  }

  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    {
      cookies: {
        getAll() {
          return document.cookie?.split(';')?.map((cookie) => {
            const [name, ...rest] = cookie?.trim()?.split('=');
            return { name, value: decodeURIComponent(rest?.join('=')) };
          });
        },
        setAll(cookiesToSet) {
          cookiesToSet?.forEach(({ name, value, options }) => {
            let cookieString = `${name}=${encodeURIComponent(value)}; Path=${options?.path || '/'}; Secure; SameSite=None`;

            if (options?.maxAge) {
              cookieString += `; max-age=${options?.maxAge}`;
            }
            if (options?.domain) {
              cookieString += `; domain=${options?.domain}`;
            }
            if (options?.expires) {
              cookieString += `; expires=${options?.expires}`;
            }

            document.cookie = cookieString;
          });
        },
      },
    }
  );
}

// Default export for module resolution
export default createClient;
function getSupabaseClient(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: getSupabaseClient is not implemented yet.', args);
  return null;
}

export { getSupabaseClient };
function supabase(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: supabase is not implemented yet.', args);
  return null;
}

export { supabase };
